import script from "./TableView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableView.vue?vue&type=script&setup=true&lang=ts"

import "./TableView.vue?vue&type=style&index=0&id=07ff1f76&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07ff1f76"]])

export default __exports__